/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H133162 on 2/4/2021.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {injectIntl, FormattedMessage} from 'react-intl';
import {Button, Card, Grid, Modal} from '@scuf/common';
import * as FaultActions from "../FaultActions";
import Loader from '../../common/Loader'
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";
import ActionLogTable from "./ActionLogTable";

class ActionLogModal extends React.Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        const {fault} = this.props
        const external = userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)
        this.props.FaultActions.fetchActionLog(fault.assetId, fault.faultId, external)
    }

    render() {
        const {intl, fault} = this.props;

        return (
            <Modal closeIcon={false} onClose={() => this.props.closeModalWindow()} open={this.props.modalWindowOpen}
                   closeOnDimmerClick={true} className="closed-modal">
                <Modal.Header>
                    <FormattedMessage id="fault.detail.title.actionlog"/>
                </Modal.Header>
                <Modal.Content scrolling={true} className="modal--content">
                    <Grid>
                        <Grid.Row id="action-log">
                            <Grid.Column width={12}>
                                <Card className="grid--card">
                                    <Card.Content>
                                        <ActionLogTable actionLog={fault.actionLog} currentFaultId={fault.faultId}/>
                                    </Card.Content>
                                </Card>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Content>
                <Modal.Footer>
                    <div className="closedModal-buttons">
                        <Button className="mobile-max-width-button"
                                content={intl.formatMessage({id: "fault.detail.action.close"})}
                                onClick={() => this.props.closeModalWindow()} size="medium" type="secondary"/>
                    </div>
                </Modal.Footer>
                <Loader loading={this.props.loading}/>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        fault: state.fault,
        loading: state.fault.fetchCount > 0,
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FaultActions: bindActionCreators(FaultActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(ActionLogModal)))